import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

import { formatNumber } from 'utils/currencyFormat';

function MartketDemandChart(props) {
  const { data, provinceName } = props;

  return (
    <ResponsiveContainer width="100%" height={380}>
      <ComposedChart
        data={data}
        margin={{
          top: 10,
          right: 10,
          left: 0,
          bottom: 0,
        }}
        barCategoryGap="20%"
        barGap={4}
      >
        <CartesianGrid
          strokeDasharray="4 4"
          vertical={false}
          stroke="#E5E6EB"
        />

        <XAxis
          dataKey="name"
          tick={{ fontSize: 13, fill: '#86909C' }}
          axisLine={{ stroke: '#E5E6EB' }}
          tickLine={false}
        />

        <YAxis
          tick={{ fontSize: 13, fill: '#86909C' }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
          domain={[0, 'auto']}
          tickFormatter={(v) => `${formatNumber(v)}%`}
        />

        <Tooltip
          formatter={(value, name) => [`${formatNumber(value)}%`, name]}
          cursor={{ fill: 'rgba(0,0,0,0.04)' }}
        />

        <Bar
          dataKey="search"
          name={`Tìm kiếm ${provinceName}`}
          fill="#F46A6A"
          barSize={52}
        />

        <Bar
          dataKey="booking"
          name="Đặt chỗ của tôi"
          fill="#00BBFF"
          barSize={52}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}

MartketDemandChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    search: PropTypes.number,
    booking: PropTypes.number,
  })),
  provinceName: PropTypes.string,
};

MartketDemandChart.defaultProps = {
  data: [],
  provinceName: 'TP.Hồ Chí Minh',
};

export default React.memo(MartketDemandChart);
